import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <Navbar expand="lg" variant="dark" className="bg-navy sticky-top shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src="/assets/logos/PNG/Logo 6  white.png"
            height="40"
            className="me-2"
            style={{ width: 'auto', objectFit: 'contain' }}
            alt="515 Soccer Academy"
          />
          <span className="fw-bold">515 Soccer Academy</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" active={location.pathname === '/'}>Home</Nav.Link>
            
            <NavDropdown title="Programs" id="basic-nav-dropdown" active={location.pathname.includes('/academy') || location.pathname.includes('/select')}>
              <NavDropdown.Item as={Link} to="/academy">Academy (U9-U10)</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/select">Select (U11+)</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/registration" active={location.pathname === '/registration'}>Registration</Nav.Link>
            <Nav.Link as={Link} to="/fees" active={location.pathname === '/fees'}>Fees</Nav.Link>
            <Nav.Link as={Link} to="/sponsors" active={location.pathname === '/sponsors'}>Sponsors</Nav.Link>
            <Nav.Link as={Link} to="/about" active={location.pathname === '/about'}>About Us</Nav.Link>
            <Nav.Link as={Link} to="/contact" active={location.pathname === '/contact'}>Contact</Nav.Link>
          </Nav>
          <div className="d-flex ms-lg-3">
             <Link 
                to="/store"
                className="btn btn-outline-light btn-sm me-2"
              >
                Store
              </Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
